export default {
  REGISTRATION: "REGISTRATION",
  PERSONAL_DATA: "PERSONAL_DATA",
  LOCATION_DATA: "LOCATION_DATA",
  CITIZENSHIP_DATA: "CITIZENSHIP_DATA",
  MIDDLE_EDUCATION: "MIDDLE_EDUCATION",
  MOVE_STUDY: "MOVE_STUDY_AND_SECOND_SPECIALTY",
  DTM_RESULT: "DTM_RESULT",
  COURSE_OF_STUDY: "COURSE_OF_STUDY",
};
